import './styles.css';
import { CircularProgress } from '@material-ui/core';
import { WithRouter } from 'decorators/withRouter';
import { connect } from 'react-redux';
import { PureComponent } from 'react';

interface IProps {
  isFree: boolean;
}

@WithRouter()
class SignIn extends PureComponent<IProps, any> {

  render() {
    const { isFree } = this.props;

    if (isFree === undefined) {
      return (
        <div className='loading-sign'>
          <CircularProgress />
        </div>
      );
    }

    return <div />;
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  ...ownProps,
  isFree: (state.template.course || {}).isFree || false,
});

export default connect(mapStateToProps, { })(SignIn);
